<template>
	<div class="chat-container w-100 position-relative">
		<div class="container px-4 mt-4 pt-2">
    	<div class="">
    		<p class="mb-1 heading-5 text-24 font-semibold">{{$t('profile.create-your-account')}}</p>
    		<p class="mb-0 body-1 font-regular text-14">{{$t('profile.already-registered')}}, <router-link :to="'/'+getMerchant().code+'/login'"><span class="text-green font-semibold text-16"><u>{{$t('profile.login-here')}}</u></span></router-link></p>
    		<div class="mb-3 mt-4 pb-2">
          <p class="mb-1 font-regular body-2 text-color-dark">Title <span class="text-danger">*</span></p>
          <v-select class="general-select-border" :clearable="false" :options="genders" v-model="form.gender">
          </v-select>
        </div>
        <div class="mb-3 row pb-2">
          <div class="col-6">
            <p class="mb-1 font-regular body-2 text-color-dark">{{$t('ticket-cart.first-name')}} <span class="text-danger">*</span></p>
            <input type="text" v-model="form.first_name" class="form-control border-semi-grey rounded-6 px-2 body-1-2 mb-1" placeholder="Jhon" />
          </div>
          <div class="col-6">
            <p class="mb-1 font-regular body-2 text-color-dark">{{$t('ticket-cart.last-name')}}</p>
            <input type="text" v-model="form.last_name" class="form-control border-semi-grey rounded-6 px-2 body-1-2 mb-1" :placeholder="$t('ticket-cart.last-name')" />
          </div>
        </div>
				<div class="w-100 mb-3 pb-2">
					<p class="mb-0 font-regular body-2 text-color-dark">{{$t('ticket-cart.email')}} <span class="text-danger">*</span></p>
					<input type="email" v-model="form.email" class="form-control border-semi-grey rounded-6 px-2 body-1-2 mb-2" placeholder="user@guestaps.com">
					<div class="w-100">
						<img src="../../assets/img/icon/info.png" class="align-top d-inline-block mt-1 mr-1" height="12" width="12">
						<p class="mb-0 body-2 font-regular text-12 d-inline-block w-90">{{$t("profile.register-sub")}}</p>
					</div>
				</div>
    		<div class="row mb-3 pb-2">
	        <div class="col-4">
	          <p class="mb-1 font-regular body-2 text-color-dark">{{$t('general.country-code')}}</p>
	        </div>
	        <div class="col-8">
	          <p class="mb-1 font-regular body-2 text-color-dark">{{$t('general.mobile-number')}} <span class="text-danger">*</span></p>
	        </div>
	        <div class="col-4">
	          <v-select class="general-select-border" :clearable="false" :options="country" v-model="form.dial_code" label="dial_code">
							<template #option="{ dial_code, code }">
								<span class="body-2 mb-0">{{code}} </span>|<span class="body-2 text-color-dark"> {{dial_code}}</span>
							</template>
          	</v-select>
	        </div>
	        <div class="col-8">
	          <input type="text" v-model="form.phone_number" class="form-control border-semi-grey rounded-6 px-2 body-1-2 mb-1">
	        </div>
      	</div>
      	<div class="w-100 mb-5">
	      	<p class="mb-1 font-regular body-2 text-color-dark">{{$t('general.address')}} <span class="text-danger">*</span></p>
					<textarea rows="2" class="form-control border-semi-grey rounded-6 px-2 body-1" v-model="form.address"></textarea>
	      </div>
    	</div>
  	</div>
		<div class="container pb-4">
      <div class="px-2">
      	<div v-if="error.show" class="p-3 mb-3 border radius-0" style="background-color: rgb(255, 243, 243);border-color: #feb8b8 !important;">
	        <div class="row grid-slim-row">
	          <div class="col-12 text-center">
	            <p class="mb-0 body-3-1">{{error.message}}</p>
	          </div>
	        </div>
	      </div>
      	<div class="rounded-6 px-4 py-3 text-center" @click="registerSubmit" :class="{'bg-green cursor-pointer': is_register_form_valid, 'bg-green-disabled cursor-disable' : !is_register_form_valid || push_loading}">
      		<pulse-loader :loading="push_loading" v-if="push_loading"></pulse-loader>
          <p v-else class="text-white body-15 mb-0 ls-1-25">{{$t('profile.register')}}</p>
        </div>
      </div>
  	</div>
	</div>
</template>
<script>
	import country from "@/data/country"
	const { email,required } = require("vuelidate/lib/validators");
	import {post} from '@/services/index.js';
	import {checkDataExist} from '@/utils/index.js';
	import {mapActions,mapGetters,mapMutations} from 'vuex';


	export default{
		metaInfo(){
      return {
        title: 'Register',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
		data(){
			return{
				genders: ['Mr',"Mrs"],
				country: country,
				push_loading: false,
				error:{
					show: false,
					message: ''
				},
				form:{
					gender: 'Mr',
					first_name: '',
					last_name: '',
					email: '',
					phone_number: '',
					dial_code: {},
					address: ''
				}
			}
		},
		validations: {
      form: {
        email:{
         	required,
          email
        },
        first_name:{
        	required
        },
      }
    },
    mounted(){
    	if (!this.isNotLogin()) {
    		this.$router.push({
    			path: '/'+this.getMerchant().code+'/account'
    		})
    	}
    	this.form.dial_code = this.country.find(x => x.code == 'ID')
    },
    computed:{
    	is_register_form_valid(){
        return (this.$v.form.email.$invalid == false && this.$v.form.first_name.$invalid == false && this.form.address != '' && this.form.phone_number !='') ? true : false
      }
    },
		methods:{
			...mapGetters(['isNotLogin','getMerchant','getActiveRoute','getMetaTitleTemplate']),
			...mapActions(['setToken','setUser','setForgotPassword']),
			registerSubmit(){
				if(this.is_register_form_valid && !this.push_loading){

					this.push_loading = true

					let params = {}
					params.gender = this.form.gender
					params.first_name = this.form.first_name
					params.last_name = this.form.last_name
					params.email = this.form.email
					params.address = this.form.address
					params.merchant_id = this.getMerchant().id
					if (this.form.phone_number != '') {
						params.phone = this.form.dial_code.dial_code+this.form.phone_number
					}

					post("BASE","email-register-user",params).then(response=>{
						let res = response.data
						if (checkDataExist(res.access_token)) {
							this.setToken({
								access: res.access_token,
      					refresh: res.refresh_token
							})
							this.setUser(res.user)
							this.setForgotPassword("")
							if(this.getActiveRoute() != ''){
								this.$router.push({
									path: '/'+this.getMerchant().code+'/'+this.getActiveRoute()
								})
							}else{
								this.$router.push({
									path: '/'+this.getMerchant().code+'/account'
								})
							}
						}else{
							this.error.show = true
							this.error.message = res.message	
						}
						this.push_loading = false
					})
				}
			}
		}
	}
</script>
<style scoped>
	.px0{
		padding-left: 0px!important;
		padding-right: 0px!important;
	}
	.text-danger{
		color: red;
	}
	.cursor-disable{
		cursor: not-allowed;
	}
</style>


// WEBPACK FOOTER //
// src/pages/general/Register.vue